module.exports = {
    "": {
        "project-id-version": "TS.InternetSales.Static",
        "report-msgid-bugs-to": "",
        "pot-creation-date": "2024-11-04 10:14-0500",
        "po-revision-date": "2024-11-04 10:24-0500",
        "last-translator": "Peter Perron <peter.perron@solutionstlm.com>",
        "language-team": "English <http://example.com/projects/internet-sales-30/internet-sales-20-is3-static/en/>",
        "language": "en",
        "mime-version": "1.0",
        "content-type": "text/plain; charset=UTF-8",
        "content-transfer-encoding": "8bit",
        "plural-forms": "nplurals=2; plural=n != 1;",
        "x-generator": "Poedit 3.4.2"
    },
    "# d’abonné ici": [
        null,
        "membership # here"
    ],
    "(valeur de {amount})": [
        null,
        "(amount of {amount})"
    ],
    "* Le prix inclut les taxes et les frais de service de {fees} par billet. Quantités limitées.": [
        null,
        "* Prices include taxes and {fees} fees per ticket. Limited quantity."
    ],
    "--- Sélectionner un pays ---": [
        null,
        "--- Select a country ---"
    ],
    ":": [
        null,
        ": "
    ],
    "A la": [
        null,
        "At the"
    ],
    "AUCUN": [
        null,
        "NONE"
    ],
    "Afin de pouvoir continuer vos achats, vous devez aller dans les options de votre navigateur pour procéder à l'activation de vos témoins (cookies).": [
        null,
        "In order to be able to continue your purchase, you must enable the cookies in the settings of your browser."
    ],
    "Afin de pouvoir continuer vos achats, vous devez autoriser la": [
        null,
        "In order to be able to continue your purchase, you must authorize"
    ],
    "Ajout d'une carte": [
        null,
        "Add a card"
    ],
    "Ajouter": [
        null,
        "Add"
    ],
    "Ajouter et continuer mes achats": [
        null,
        "Add and continue shopping"
    ],
    "Ajouter une carte cadeau": [
        null,
        "Use a prepaid card"
    ],
    "Ajouter à mon panier d'achat au tarif {name}": [
        null,
        "Add to cart at {name} rate"
    ],
    "American Express": [
        null,
        "American Express"
    ],
    "Annuler": [
        null,
        "Cancel"
    ],
    "Au": [
        null,
        "At the"
    ],
    "Aucun": [
        null,
        "None"
    ],
    "Aucun profil est connecte, la page sera actualisee": [
        null,
        "No profile is connected, the page will be refreshed"
    ],
    "Aucune date disponible": [
        null,
        "No date available"
    ],
    "Aucune représentation disponible pour le moment...": [
        null,
        "No dates available for the moment..."
    ],
    "Autoriser la billetterie Reservatech.net pour l'achat de mes billets": [
        null,
        "Authorize the Reservatech.net's ticketing system to complete my purchase"
    ],
    "Autre": [
        null,
        "Other"
    ],
    "Autre methode": [
        null,
        "Other method"
    ],
    "Avant de procéder": [
        null,
        "Before you proceed"
    ],
    "Billet bloqué": [
        null,
        "Ticket blocked"
    ],
    "Billet désactivé": [
        null,
        "Ticket deactivated"
    ],
    "Billet remplacé": [
        null,
        "Ticket replaced"
    ],
    "Billet réimprimé": [
        null,
        "Ticket reissued"
    ],
    "Billets en trop : {qty}": [
        null,
        "Excess tickets : {qty}"
    ],
    "Billets non distribués : {qty}": [
        null,
        "Undistributed tickets : {qty}"
    ],
    "Carte cadeau": [
        null,
        "Prepaid card"
    ],
    "Ce siege ne vous convient pas? Cliquez sur le plan pour chercher un billet a l'endroit de votre choix.": [
        "Ces places ne vous conviennent pas? Cliquez sur le plan pour chercher des billets a l'endroit de votre choix.",
        "Don't like this place? Click on the plan to search a seat in the area of your choice.",
        "Don't like those places? Click on the plan to search seats in the area of your choice."
    ],
    "Certains billets de votre sélection sont déjà dans votre panier d'achats.": [
        null,
        "Some tickets in your selection were already added to your shopping cart."
    ],
    "Changer": [
        null,
        "Change"
    ],
    "Chargement de la programmation en cours...": [
        null,
        "Loading..."
    ],
    "Chargement des dates en cours...": [
        null,
        "Loading..."
    ],
    "Chargement...": [
        null,
        "Loading..."
    ],
    "Chercher": [
        null,
        "Search"
    ],
    "Chercher dans une autre section": [
        null,
        "Look into another section"
    ],
    "Chercher les meilleures places": [
        null,
        "Search for the best seats"
    ],
    "Choisir sur le plan": [
        null,
        "Choose on plan"
    ],
    "Choisissez un evenement parmi les suivants": [
        "Choisissez {n} evenements parmi les suivants",
        "Choose an event among the following",
        "Choose {n} events among the following"
    ],
    "Choisissez votre promotion": [
        null,
        "Select your promotion"
    ],
    "Choisissez votre tarif": [
        null,
        "Choose your rate"
    ],
    "Choix de places": [
        null,
        "Seat selection"
    ],
    "Choix du tarif": [
        null,
        "Rate selection"
    ],
    "Cliquez ici si vous désirez la désactiver.": [
        null,
        "Click here to deactivate it."
    ],
    "Cliquez sur le plan pour chercher des sieges a l'endroit de votre choix.": [
        null,
        "Click on the plan to search for seats in the area you'd like to be."
    ],
    "Cliquez sur le plan pour sélectionner les sièges de votre choix": [
        null,
        "Click on the plan to select seats you'd like to have."
    ],
    "Cliquez sur les sièges que vous désirez réserver.": [
        null,
        "Click on the seats you would want to reserve."
    ],
    "Code incorrect": [
        null,
        "Incorrect code"
    ],
    "Code postal": [
        null,
        "Postal code"
    ],
    "Combien de billets désirez-vous?": [
        null,
        "How many tickets do you want?"
    ],
    "Combien de forfaits désirez-vous?": [
        null,
        "How many tickets do you want?"
    ],
    "Compléter votre forfait parmi les événements suivants": [
        null,
        "Complete your package with the following items"
    ],
    "Confirmer": [
        null,
        "Confirm"
    ],
    "Continuer en tant qu'invité": [
        null,
        "Continue as a guest"
    ],
    "Courriel invalide": [
        null,
        "Invalid email address"
    ],
    "D'accord!": [
        null,
        "All right!"
    ],
    "Dans quelle section": [
        null,
        "In which section"
    ],
    "Date à déterminer": [
        null,
        "Date to be determined"
    ],
    "Devenir membre": [
        null,
        "Become member"
    ],
    "Donnée inaccessible": [
        null,
        "Information not available"
    ],
    "Décharge de responsabilité": [
        "Décharges de responsabilité",
        "Liability waiver",
        "Liability waivers"
    ],
    "Désirez-vous vraiment annuler votre réservation pour l'événement à venir?": [
        null,
        "Would you like to cancel your reservation for the incoming event?"
    ],
    "Désolé, certains billets de votre sélection ne sont plus disponibles. Veuillez en choisir de nouveau.": [
        null,
        "Sorry, some of the tickets in your selection aren't available anymore. Please select other seats."
    ],
    "Enlever 1 billet pour profiter de ce tarif": [
        "Enlever {n} billets pour profiter de ce tarif",
        "Remove 1 ticket to take advantage of this rate",
        "Remove {n} tickets to take advantage of this rate"
    ],
    "Entrez votre # d’abonné ici": [
        null,
        "Enter your membership # here"
    ],
    "Envoyer": [
        null,
        "Send"
    ],
    "Erreur lors de la recherche de billets à cet endroit.": [
        null,
        "Error while searching tickets around this place"
    ],
    "Fermer la session": [
        null,
        "Logout"
    ],
    "File d'attente": [
        null,
        "Waiting line"
    ],
    "Frais de livraison": [
        null,
        "Shipping fees"
    ],
    "ICI": [
        null,
        "HERE"
    ],
    "IMPORTANT": [
        null,
        "IMPORTANT"
    ],
    "Identifiez-vous": [
        null,
        "Tell us about you"
    ],
    "Il n'y a aucun tarif disponible dans cette section pour le moment. Veuillez sélectionner un autre siège.": [
        null,
        "There are no rates available in this section for the moment. Please choose some other seats."
    ],
    "Il vous manque encore un evenement dans votre choix pour continuer.": [
        "Il vous manque encore {n} evenements dans votre choix pour continuer.",
        "Choose one more event to continue.",
        "Choose {n} more events to continue."
    ],
    "Il vous manque encore un evenement obligatoire dans votre choix pour continuer.": [
        "Il vous manque encore {n} evenements oligatoires dans votre choix pour continuer.",
        "Choose one more event to continue.",
        "Choose {n} more events to continue."
    ],
    "Inclut des frais de": [
        null,
        "Include fees of"
    ],
    "Infolettre": [
        "Infolettres",
        "Newsletter",
        "Newsletters"
    ],
    "Informations d'inscription": [
        null,
        " Form Informations"
    ],
    "Informations du compte Reservatech.net": [
        null,
        "Reservatech.net Account Informations"
    ],
    "Inscrire votre pays": [
        null,
        "Enter your country"
    ],
    "Inscrivez vos informations pour que nous puissions vous contacter en cas de supplémentaire.": [
        null,
        "Enter your information so we can contact in case of an additional representation."
    ],
    "Invalide - {reason}": [
        null,
        "Invalid - {reason}"
    ],
    "J'accepte que mon adresse courriel soit partagée aux producteurs pour l'inscription à des infolettres": [
        null,
        "I accept that my email address could be shared to the producer for newsletter subscription."
    ],
    "J'ai activé mes cookies, réessayer": [
        null,
        "I've got my cookies enabled, retry"
    ],
    "J'ai lu et accepte la": [
        null,
        "I have read and accept the"
    ],
    "J'ai lu et accepte la décharge": [
        null,
        "I have read and accept the waiver terms"
    ],
    "J'ai lu et accepte les": [
        null,
        "I have read and I accept the"
    ],
    "J'ai lu et accepte les politiques d'achats": [
        null,
        "I have read and I accept the purchasing policy"
    ],
    "Je désire faire une demande de modification": [
        null,
        "I would like to ask for a modification"
    ],
    "Je désire renouveler": [
        null,
        "I would like to renew"
    ],
    "Je ne souhaite pas renouveler": [
        null,
        "I don’t want to renew"
    ],
    "Je paie avec {name}": [
        null,
        "I pay with {name}"
    ],
    "Je récupérerai mes billets au guichet": [
        null,
        "At the box office"
    ],
    "Je suis membre": [
        null,
        "I am a member"
    ],
    "Je veux": [
        null,
        "I want"
    ],
    "L'achat de billet en ligne est propulsé par la billetterie": [
        null,
        "The ticket sales is powered by the ticketing system"
    ],
    "L'adresse courriel associée à ce code ne correspond pas à l'adresse courriel de votre profil. Veuillez vous déconnecter et essayer de nouveau.": [
        null,
        "Your profile's email address doesn't match with this promo code. You can disconnect from this account and try again."
    ],
    "L'item que vous désirez retirer du panier est nécéssaire pour le produit suivant": [
        "L'item que vous désirez retirer est nécéssaire pour les produits suivants",
        "The item you want to remove is needed by the following item",
        "The item you want to remove is needed by the following items"
    ],
    "La carte n'est pas utilisable pour chacun des événements de votre panier.": [
        null,
        "This card is not usable for each item in your cart."
    ],
    "Laissez votre navigateur ouvert sur cette page et surveillez la. Lorsque votre tour sera venu, l'achat de billet apparaîtra. Prenez garde, actualiser cette page empêcherait votre navigateur de vérifier si le système vous a attribué une place.": [
        null,
        "Leave your browser open on this page and regularly look at it. When it is your turn, you'll be redirected to the online store. Be careful, refreshing this page can prevent your browser from being up to date with your place in the line."
    ],
    "Le forfait n'est plus en vente présentement": [
        null,
        "This package deal is currently not on sale"
    ],
    "Le montant de la carte cadeau entrée est insuffisant.": [
        null,
        "The card’s amount is not sufficient."
    ],
    "Le montant de la carte cadeau entrée est invalide.": [
        null,
        "The card’s amount is invalid."
    ],
    "Le nombre de forfait a été épuisés": [
        null,
        "No more package deals available"
    ],
    "Le numéro de carte est invalide.": [
        null,
        "The card’s number is invalid."
    ],
    "Limite atteinte!": [
        null,
        "Limit reached!"
    ],
    "Manque 1 billet pour profiter de ce tarif": [
        "Manque {n} billets pour profiter de ce tarif",
        "One more ticket is needed to use this rate",
        "{n} more tickets are needed to use this rate"
    ],
    "Manque 1 billet pour profiter de cette vente": [
        "Manque {n} billets pour profiter de cette vente",
        "One more ticket is needed to continue with this purchase",
        "{n} more tickets are needed to continue with this purchase"
    ],
    "Maximum de 1 billet par commande": [
        "Maximum de {n} billets par commande",
        "1 ticket maximum per order",
        "{n} tickets maximum per order"
    ],
    "Merci !": [
        null,
        "Thank you !"
    ],
    "Merci de patienter.": [
        null,
        "Thank you for your patience."
    ],
    "Mise en vente": [
        null,
        "Sales"
    ],
    "Modifier": [
        null,
        "Modify"
    ],
    "Modifier le formulaire": [
        null,
        "Edit the form"
    ],
    "Modifier le formulaire du panier": [
        null,
        "Edit cart's form"
    ],
    "Modifier vos informations d'inscription": [
        null,
        "Edit your form informations"
    ],
    "Mon panier": [
        null,
        "My cart"
    ],
    "Montant": [
        null,
        "Amount"
    ],
    "Montant personnalisé": [
        null,
        "Amount of your choice"
    ],
    "Montant à payer": [
        null,
        "Amount to pay"
    ],
    "Montants": [
        null,
        "Amounts"
    ],
    "Mot de passe incorrect": [
        null,
        "Incorrect password"
    ],
    "Mot de passe oublié ?": [
        null,
        "Forgot your password?"
    ],
    "Ne pas actualiser cette page - Le système travaille pour vous!": [
        null,
        "Do not refresh this page - The system does it for you!"
    ],
    "No civique et rue": [
        null,
        "Street number and name"
    ],
    "Nombre de billets désirés": [
        null,
        "Number of tickets required"
    ],
    "Nombre de participants": [
        null,
        "Number of participants"
    ],
    "Non disponible": [
        null,
        "Unavailable"
    ],
    "Non, conservez mes billets": [
        null,
        "No, keep my tickets"
    ],
    "Nous vous enverrons un courriel contenant un lien. Veuillez cliquer sur ce lien pour réinitialiser votre mot de passe.": [
        null,
        "We wills end you an email with a link. Please click on this link to reset your password."
    ],
    "Numéro de carte invalide!": [
        null,
        "Invalid card number."
    ],
    "Nécessite 1 billet pour profiter de ce tarif": [
        "Nécessite {n} billets pour profiter de ce tarif",
        "Need at least 1 ticket to use this rate",
        "Need at least {n} tickets to use this rate"
    ],
    "Nécessite un multiple de 1 billet pour profiter de ce tarif": [
        "Nécessite un multiple de {n} billets pour profiter de ce tarif",
        "Need a multiple of 1 ticket to use this rate",
        "Need a multiple of {n} tickets to use this rate"
    ],
    "Nécessite un multiple de 1 billet pour profiter de cette vente": [
        "Nécessite un multiple de {n} billets pour profiter de cette vente",
        "Need a multiple of 1 ticket to continue with this purchase",
        "Need a multiple of {n} tickets to continue with this purchase"
    ],
    "Nécessite une carte de crédit {creditCardName}": [
        null,
        "A {creditCardName} credit card is needed"
    ],
    "Nécessite une carte {cardName}": [
        null,
        "A {cardName} card is required"
    ],
    "OK": [
        null,
        "OK"
    ],
    "Oui, annulez ma réservation": [
        null,
        "Yes, cancel my reservation"
    ],
    "Participants confirmés": [
        null,
        "Confirmed participants"
    ],
    "Passer à la caisse": [
        null,
        "Checkout"
    ],
    "Plus d'informations...": [
        null,
        "More information..."
    ],
    "Politique d'achat": [
        "Politiques d'achat",
        "Purchasing policy",
        "Purchasing policies"
    ],
    "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie au {phone} ou, sans frais, au {tollfree}.": [
        null,
        "For more information about this procedure, please give us a call at {phone}, or toll-free at {tollfree}."
    ],
    "Pour plus d’informations sur cette procédure, n’hésitez pas à communiquer avec la billetterie.": [
        null,
        "For more information about this procedure, please give us a call at {phone}, or toll-free at {tollfree}."
    ],
    "Pour plus d’informations sur cette procédure, vous retrouverez l'information de blocage/activation des témoins (cookies) en cliquant": [
        null,
        "If you want to know more on how to get your cookies enabled, click"
    ],
    "Promotion non trouvée": [
        null,
        "Promotion not found"
    ],
    "Quantité désirée ": [
        null,
        "Desired quantity "
    ],
    "Quantités": [
        null,
        "Quantities"
    ],
    "Quels montants désirez-vous?": [
        null,
        "Which amounts do you want?"
    ],
    "Recherche avancée": [
        null,
        "Advanced search"
    ],
    "Requis": [
        null,
        "Required"
    ],
    "Reservatech.net": [
        null,
        "Reservatech.net"
    ],
    "Retirer aussi ce produit du panier": [
        "Retirer aussi tous ces produits du panier",
        "Remove it from my cart as well",
        "Remove all of them from my cart as well"
    ],
    "Récupération de votre commande": [
        null,
        "Delivery method"
    ],
    "SUIVANT": [
        null,
        "NEXT"
    ],
    "Si vous détenez un **CODE DE PROMOTION**, cliquez ici.": [
        null,
        "If you have a **PROMO CODE** click here."
    ],
    "Si vous ne voyez pas votre nom dans la liste et que vous vous êtes inscrit en ligne": [
        null,
        "If you can't find your name in the list and you registered online"
    ],
    "Siege propose": [
        "Sieges proposes",
        "Proposed seat",
        "Proposed seats"
    ],
    "Sous total": [
        null,
        "Subtotal"
    ],
    "Sélection de billets": [
        null,
        "Choose tickets"
    ],
    "Sélectionner un tarif": [
        null,
        "Choose a rate"
    ],
    "Sélectionnez une section": [
        null,
        "Choose a section"
    ],
    "TOUS": [
        null,
        "ALL"
    ],
    "Temps restant": [
        null,
        "Remaining time"
    ],
    "Total": [
        null,
        "Total"
    ],
    "Total de la facture": [
        null,
        "Receipt total"
    ],
    "Tous": [
        null,
        "All"
    ],
    "Toute les sections": [
        null,
        "All sections"
    ],
    "Transaction refusée": [
        null,
        "Transaction refused"
    ],
    "Trouvez-moi": [
        null,
        "Find me"
    ],
    "Téléphone": [
        null,
        "Phone"
    ],
    "Une erreur est survenue": [
        null,
        "Something went wrong"
    ],
    "Une erreur est survenue ({key})": [
        null,
        "Something went wrong ({key})"
    ],
    "Une erreur est survenue. Veuillez réessayer plus tard.": [
        null,
        "Something went wrong. Please try again later."
    ],
    "Utiliser une carte cadeau": [
        null,
        "Use a prepaid card"
    ],
    "Utilisez ce code lors du paiement pour échanger votre carte cadeau.": [
        null,
        "Use this code in your next purchase to redeem your gift card."
    ],
    "Utilisez ce code lors du paiement pour échanger votre chèque-cadeau.": [
        null,
        "Use this code in your next purchase to redeem your gift card."
    ],
    "Validation de la carte": [
        null,
        "Card validation"
    ],
    "Valider": [
        null,
        "Check"
    ],
    "Version imprimable": [
        null,
        "Printable version"
    ],
    "Veuillez augmenter votre luminosité": [
        null,
        "Please increase your brightness"
    ],
    "Veuillez entrer le code de promotion": [
        null,
        "Please enter your promo code"
    ],
    "Veuillez entrer le numéro de votre carte cadeau": [
        null,
        "Please enter your prepaid card number"
    ],
    "Veuillez entrer les 4 premiers chiffres de votre carte de débit Desjardins": [
        null,
        "Please enter your Desjardins debit card number (16 digits)"
    ],
    "Veuillez entrer un code promo": [
        null,
        "Please enter your promo code"
    ],
    "Veuillez patentier...": [
        null,
        "Please wait..."
    ],
    "Veuillez remplir vos informations d'inscription": [
        null,
        "Please fill your form to continue"
    ],
    "Veuillez sélectionner la méthode de récupération": [
        null,
        "Please choose the delivery method"
    ],
    "Visionner sur le plan": [
        null,
        "View on plan"
    ],
    "Voir notre promotion": [
        "Voir nos promotions",
        "See our promotion",
        "See our promotions"
    ],
    "Voir plus d'informations": [
        null,
        "More information..."
    ],
    "Vos cartes cadeaux électroniques": [
        null,
        "Your electronic gift cards"
    ],
    "Vos cartes de membres": [
        null,
        "Your memberships"
    ],
    "Vos chèques-cadeaux électroniques": [
        null,
        "Your electronic gift certificates"
    ],
    "Vos coordonnées": [
        null,
        "Your coordinates"
    ],
    "Vos produits": [
        null,
        "Your products"
    ],
    "Vos témoins (cookies) sont désactivés": [
        null,
        "Your cookies are disabled"
    ],
    "Votre carte cadeau électronique": [
        null,
        "Your electronic gift card"
    ],
    "Votre chèque-cadeau électronique": [
        null,
        "Your electronic gift certificate"
    ],
    "Votre nombre de forfaits ": [
        null,
        "Your packages number "
    ],
    "Votre panier": [
        null,
        "Your shopping cart"
    ],
    "Votre panier d'achat": [
        null,
        "Your shopping cart"
    ],
    "Votre panier est presentement vide, la page sera actualisee": [
        null,
        "Your cart is empty, the page will be refreshed"
    ],
    "Votre panier est présentement vide, la page sera actualisee": [
        null,
        "Your cart is empty, the page will be refreshed"
    ],
    "Votre sélection": [
        null,
        "Your selection"
    ],
    "Votre sélection laisse un ou plusieurs siège(s) vide(s) isolé(s) dans la salle. Veuillez modifier votre sélection.": [
        null,
        "Your selection leaves one or more isolated seats in the venue. Please change your selection so you don't leave an empty seat alone."
    ],
    "Voulez-vous vraiment retirer ce billet?": [
        "Voulez-vous vraiment retirer ces billets?",
        "Do you really want to remove this seat?",
        "Do you really want to remove these seats?"
    ],
    "Vous avez déjà entré cette carte cadeau.": [
        null,
        "You have already added that prepaid card."
    ],
    "Vous avez dépassé le nombre d'evenements autorises de {n} pour continuer.": [
        null,
        "You have selected {n} event(s) over the maximum allowed."
    ],
    "Vous avez dépassé le nombre d'evenements obligatoire autorises de {n} pour continuer.": [
        null,
        "You have selected {n} event(s) over the maximum allowed."
    ],
    "Vous avez un code promo?": [
        null,
        "Do you have a promo code?"
    ],
    "Vous avez une promotion présentement active.": [
        null,
        "You have a special promo activated."
    ],
    "Vous avez votre place! Nous vous transférons à cet": [
        null,
        "You've got your place! Let's move at this"
    ],
    "Vous devez accepter les décharges de responsabilités": [
        null,
        "You must accept the liability waivers"
    ],
    "Vous devez accepter les décharges de responsabilités et les politiques d'achats": [
        null,
        "You must accept the liability waivers and the purchasing policy"
    ],
    "Vous devez accepter les politiques d'achats": [
        null,
        "You must accept the purchasing policy"
    ],
    "Vous devez choisir de {min} à {max} items de la liste suivante": [
        null,
        "You must choose between {min} and {max} amongst the following items"
    ],
    "Vous devez choisir {n} items de la liste suivante": [
        null,
        "You must choose between {n} items amongst the following list"
    ],
    "Vous devez entrer le code postal de facturation": [
        null,
        "Please enter the billing postal code"
    ],
    "Vous devez entrer le pays de facturation": [
        null,
        "Please enter the billing country"
    ],
    "Vous devez entrer un nombre": [
        null,
        "You must enter a number"
    ],
    "Vous devez entrer vos coordonnées": [
        null,
        "You must enter your coordinates"
    ],
    "Vous devrez entrer votre adresse de facturation": [
        null,
        "Please enter the billing address"
    ],
    "Vous êtes enregistré sur la liste de rappel.": [
        null,
        "You are registered for the callback list."
    ],
    "Vous êtes présentement dans la file d'attente d'accès à l'achat de billet.": [
        null,
        "You are currently in the waiting line to access the ticket sale."
    ],
    "Vous êtes toujours présent(e) dans la file d'attente et vous conserver votre priorité.": [
        null,
        "You are still in the waiting line and you keep your priority."
    ],
    "ans": [
        null,
        "years"
    ],
    "billets": [
        null,
        "tickets"
    ],
    "billetterie": [
        null,
        "ticketing system"
    ],
    "browsing.back": [
        null,
        "Go back"
    ],
    "browsing.processing": [
        null,
        "Please wait..."
    ],
    "button.cancel": [
        null,
        "Cancel"
    ],
    "buypackage.betweeneventstitle": [
        null,
        "Choose between {min} and {max} events among the following"
    ],
    "buypackage.eventtitle": [
        null,
        "Choose some events among the following"
    ],
    "buypackage.mandatorytitle": [
        null,
        "You must choose at least one event among the following"
    ],
    "buypackage.overviewtitle": [
        null,
        "Your event(s) for this package deal"
    ],
    "cartcontent.boxoffice": [
        null,
        "At the box office"
    ],
    "cartcontent.confirmremoveitem": [
        null,
        "Do you really want to remove this item from your cart?"
    ],
    "cartcontent.confirmtitle": [
        null,
        "Confirmation"
    ],
    "cartcontent.dateformat": [
        null,
        "dddd MMMM Do, YYYY, h[:]mm a"
    ],
    "cartcontent.description": [
        null,
        "Description"
    ],
    "cartcontent.eticket": [
        null,
        "Electronic ticket"
    ],
    "cartcontent.hidedetails": [
        null,
        "Hide Details"
    ],
    "cartcontent.itemDependancyPanel.cannotRemoveTitle": [
        null,
        "Warning"
    ],
    "cartcontent.mail": [
        null,
        "By mail"
    ],
    "cartcontent.price": [
        null,
        "Price"
    ],
    "cartcontent.quantity": [
        null,
        "Quantity"
    ],
    "cartcontent.remove": [
        null,
        "remove"
    ],
    "cartcontent.removeitem": [
        null,
        "remove from cart"
    ],
    "cartcontent.setdeliverymethod": [
        null,
        "Delivery Method"
    ],
    "cartcontent.shippingfee": [
        null,
        "Shipping Fee:"
    ],
    "cartcontent.showdetails": [
        null,
        "Show Details"
    ],
    "cartcontent.total": [
        null,
        "Total: "
    ],
    "cartcontent.venue": [
        null,
        "Venue: "
    ],
    "cartwidget.cart": [
        null,
        "Cart"
    ],
    "cartwidget.checkout": [
        null,
        "Check Out"
    ],
    "cartwidget.continueshopping": [
        null,
        "Continue Shopping"
    ],
    "cartwidget.logout": [
        null,
        "Sign Out"
    ],
    "cartwidget.pleasewait": [
        null,
        "Loading..."
    ],
    "cartwidget.timeelapsed": [
        null,
        "Time elapsed"
    ],
    "cartwidget.title": [
        null,
        "View the content of your cart"
    ],
    "cartwidget.yourcartisempty": [
        null,
        "Your shopping cart is empty"
    ],
    "code promo": [
        null,
        "promo code"
    ],
    "creditcard.cardHolderName": [
        null,
        "Name on Card"
    ],
    "creditcard.cardNumber": [
        null,
        "Card Number"
    ],
    "creditcard.endingWith": [
        null,
        "ending with {number]"
    ],
    "creditcard.expirationDate": [
        null,
        "Expiration Date"
    ],
    "creditcard.masterCardAndVisa": [
        null,
        "MasterCard and Visa"
    ],
    "creditcard.rememberForNextPurchases": [
        null,
        "Remember this card for further purchases"
    ],
    "creditcard.verificationNumber": [
        null,
        "Card Validation Number"
    ],
    "creditcard.whereToFindIt": [
        null,
        "Where to find it?"
    ],
    "creditcard.withoutSpaces": [
        null,
        "without spaces"
    ],
    "décharge": [
        null,
        "waiver"
    ],
    "en savoir plus...": [
        null,
        "learn more..."
    ],
    "endroit...": [
        null,
        "place..."
    ],
    "erroronaction.title": [
        null,
        "Warning"
    ],
    "general.colon": [
        null,
        ": "
    ],
    "general.communicationerroroccuredpleaseretry": [
        null,
        "A communication error occured. Please retry."
    ],
    "general.invalidoperation": [
        null,
        "Invalid operation"
    ],
    "le {date}": [
        null,
        "on {date}"
    ],
    "login.cancel": [
        null,
        "Cancel"
    ],
    "login.confirm": [
        null,
        "Confirm"
    ],
    "login.connection": [
        null,
        "Sign In"
    ],
    "login.createaccount": [
        null,
        "Create an account"
    ],
    "login.email": [
        null,
        "E-mail address"
    ],
    "login.failedauthmsg": [
        null,
        "The email and password combination does not match"
    ],
    "login.forgotpassword": [
        null,
        "Forgot your password?"
    ],
    "login.noaccount": [
        null,
        "Don't have an account?"
    ],
    "login.password": [
        null,
        "Password"
    ],
    "login.passwordResetEmailFailed": [
        null,
        "An error occurred while sending the email. Please try again."
    ],
    "login.passwordResetEmailSuccess": [
        null,
        "An email has been send to this email address"
    ],
    "login.passwordResetTitle": [
        null,
        "Profile Email"
    ],
    "membership.addcarderror.card.notinsale": [
        null,
        "This membership card is not in currently sale"
    ],
    "membership.addcarderror.card.soldout": [
        null,
        "This card is sold out"
    ],
    "membership.addcarderror.card.ticketnotfound": [
        null,
        "There's currently no cards available"
    ],
    "membership.addcarderror.card.toomanytickets": [
        null,
        "The number of cards exceeds the maximum allowed per transaction"
    ],
    "membership.addcarderror.price.default": [
        null,
        "This rate is currently not available"
    ],
    "membership.addcarderror.price.saleended": [
        null,
        "This rate is not available anymore"
    ],
    "membership.addcarderror.price.salenotstartyet": [
        null,
        "This rate is not yet available"
    ],
    "membership.addcarderror.price.soldout": [
        null,
        "This card rate is sold out"
    ],
    "membership.alreadyamember": [
        null,
        "Already a member?"
    ],
    "membership.cardnotfound": [
        null,
        "Card not found"
    ],
    "membership.enteryourcardnumberhere": [
        null,
        "Enter your card number here"
    ],
    "membership.membershipcardnumber": [
        null,
        "membership card number"
    ],
    "membership.youarenotamember": [
        null,
        "Not a member yet?"
    ],
    "month": [
        null,
        "month"
    ],
    "ordervalidation.accept": [
        null,
        "I have read, understand and accept the"
    ],
    "ordervalidation.addoptions": [
        null,
        "Additional options"
    ],
    "ordervalidation.editprofile": [
        null,
        "Edit your profile"
    ],
    "ordervalidation.loading": [
        null,
        "Loading..."
    ],
    "ordervalidation.policies": [
        null,
        "terms and conditions"
    ],
    "ordervalidation.profileaddress": [
        null,
        "Profile Address"
    ],
    "ordervalidation.seteticketdelivery": [
        null,
        "By E-Tickets"
    ],
    "ordervalidation.setmaildelivery": [
        null,
        "By mail"
    ],
    "ordervalidation.shippingaddress": [
        null,
        "Shipping Address"
    ],
    "ordervalidation.title": [
        null,
        "Review and complete your order"
    ],
    "ordervalidation.yourinfo": [
        null,
        "Your Information"
    ],
    "payment.cardholdername": [
        null,
        "Card Holder Name"
    ],
    "payment.cardnumber": [
        null,
        "Card Number"
    ],
    "payment.cardnumberhelp": [
        null,
        "(no spaces)"
    ],
    "payment.cardvalidationnumber": [
        null,
        "3 or 4 digits code"
    ],
    "payment.carthasexpired": [
        null,
        "The transaction time has elapsed. Your shopping cart is now empty."
    ],
    "payment.completedelivery": [
        null,
        "The delivery method of at least one item has not been set."
    ],
    "payment.completetransaction": [
        null,
        "Complete your order"
    ],
    "payment.creditcardconditionnotmet": [
        null,
        "Invalid credit card type : A {creditcard} is required to complete your order with the special discount you have selected."
    ],
    "payment.cvnhelp": [
        null,
        "(back of your card)"
    ],
    "payment.expirationdate": [
        null,
        "Expiration Date"
    ],
    "payment.failedprocess": [
        null,
        "An error occured while processing your transaction"
    ],
    "payment.finalizetransaction": [
        null,
        "Complete your order"
    ],
    "payment.itemsnotinsale": [
        null,
        "The following items are no longer available for sale: "
    ],
    "payment.numberofitemshaschange": [
        null,
        "The number of items in your shopping cart has changed. Please validate its content before completing your transaction."
    ],
    "payment.pay": [
        null,
        "Pay"
    ],
    "payment.paymentinfo": [
        null,
        "Payment Information"
    ],
    "politiques d'achats": [
        null,
        "purchase policies"
    ],
    "profileedition.accountalreadyexists": [
        null,
        "An account already exists with this email"
    ],
    "profileedition.cancel": [
        null,
        "Cancel"
    ],
    "profileedition.confirm": [
        null,
        "Confirm"
    ],
    "profileedition.contact": [
        null,
        "Contact"
    ],
    "profileedition.emailformat": [
        null,
        "Invalid Email (ex: jonathan@gmail.com)"
    ],
    "profileedition.emailvalidationerror": [
        null,
        "The email validation differs from the the email"
    ],
    "profileedition.errorhasoccured": [
        null,
        "An error occurred while creating your profile, please try again"
    ],
    "profileedition.fieldformatinvalid": [
        null,
        "Some fields do not respect the valid format"
    ],
    "profileedition.optional": [
        null,
        "(Optional)"
    ],
    "profileedition.passwordformat": [
        null,
        "Password must contain at least 6 characters"
    ],
    "profileedition.passwordvalidation": [
        null,
        "Password validation: "
    ],
    "profileedition.passwordvalidationerror": [
        null,
        "The password validation differs from the password"
    ],
    "profileedition.personal": [
        null,
        "Personnel"
    ],
    "profileedition.phoneformat": [
        null,
        "Invalid Phone Format (valid format : 4185453330)"
    ],
    "profileedition.postalcodeformat": [
        null,
        "Invalid Postal Code Format"
    ],
    "profileedition.requiredfieldmissing": [
        null,
        "Some required fields have not been filled"
    ],
    "profileedition.title.create": [
        null,
        "Create your profile"
    ],
    "profileedition.title.edition": [
        null,
        "Edit your profile"
    ],
    "profileinfo.address": [
        null,
        "Address"
    ],
    "profileinfo.address2": [
        null,
        "Address 2"
    ],
    "profileinfo.city": [
        null,
        "City"
    ],
    "profileinfo.country": [
        null,
        "Country"
    ],
    "profileinfo.description": [
        null,
        "Description"
    ],
    "profileinfo.email": [
        null,
        "Email"
    ],
    "profileinfo.emailvalidation": [
        null,
        "Email validation"
    ],
    "profileinfo.female": [
        null,
        "Female"
    ],
    "profileinfo.firstname": [
        null,
        "First Name"
    ],
    "profileinfo.lastname": [
        null,
        "Last Name"
    ],
    "profileinfo.male": [
        null,
        "Male"
    ],
    "profileinfo.name": [
        null,
        "Full Name"
    ],
    "profileinfo.password": [
        null,
        "Password"
    ],
    "profileinfo.phone1": [
        null,
        "Work Phone"
    ],
    "profileinfo.phone2": [
        null,
        "Home Phone"
    ],
    "profileinfo.postalcode": [
        null,
        "Postal Code"
    ],
    "profileinfo.province": [
        null,
        "Province"
    ],
    "profileinfo.sex": [
        null,
        "Gender"
    ],
    "program.contactus.attheboxoffice": [
        null,
        "At the box office"
    ],
    "program.contactus.purschasebyphone": [
        null,
        "Purchase by phone"
    ],
    "program.eventdateinfo.buy": [
        null,
        "Buy online"
    ],
    "program.eventdateinfo.fewseats": [
        null,
        "Few Seats Remaining"
    ],
    "program.eventdateinfo.newdate": [
        null,
        "New date"
    ],
    "program.eventdateinfo.nodateavailable": [
        null,
        "No Date Available"
    ],
    "program.eventdateinfo.selectadate": [
        null,
        "Select an event"
    ],
    "program.eventdateinfo.soldout": [
        null,
        "Sold Out"
    ],
    "program.eventdateinfo.yourdate": [
        null,
        "Your event"
    ],
    "program.format.moment.datetime": [
        null,
        "YYYY MMMM DD - H [h] mm"
    ],
    "program.pricelist.startingfrom": [
        null,
        "From *"
    ],
    "program.salesinfo.buyinpresale": [
        null,
        "Buy in presale"
    ],
    "program.salesinfo.notinsale": [
        null,
        "The event is not in sale right now"
    ],
    "program.salesinfo.pastevent": [
        null,
        "Past event date"
    ],
    "program.salesinfo.public": [
        null,
        "Public"
    ],
    "program.salesinfo.soldoutevent": [
        null,
        "This event is sold out"
    ],
    "program.ticketselection.nbrticketlabel": [
        null,
        "Your number of tickets"
    ],
    "program.ticketselection.nbrtickettitle": [
        null,
        "How many tickets do you want?"
    ],
    "program.ticketselection.sectionlabel": [
        null,
        "Your section"
    ],
    "program.ticketselection.sectiontitle": [
        null,
        "Do you want to be in specific section?"
    ],
    "recherche": [
        null,
        "search"
    ],
    "retirer": [
        null,
        "remove"
    ],
    "salequestionnaire.challenge": [
        null,
        "Épreuve"
    ],
    "salequestionnaire.firstname": [
        null,
        "First Name"
    ],
    "salequestionnaire.lastname": [
        null,
        "Last Name"
    ],
    "shippingaddresspanel.addnew": [
        null,
        "Add"
    ],
    "shippingaddresspanel.allshippingaddresses": [
        null,
        "Shipping Addresses"
    ],
    "shippingaddresspanel.cancel": [
        null,
        "Cancel"
    ],
    "shippingaddresspanel.close": [
        null,
        "Close"
    ],
    "shippingaddresspanel.confirm": [
        null,
        "Confirm"
    ],
    "shippingaddresspanel.edit": [
        null,
        "Edit"
    ],
    "shippingaddresspanel.editShippingAddress": [
        null,
        "Edit your Shipping Address"
    ],
    "shippingaddresspanel.errorhasoccured": [
        null,
        "An error has occurred, please try again"
    ],
    "shippingaddresspanel.failedremove": [
        null,
        "Warning"
    ],
    "shippingaddresspanel.invalidpostalcodeformat": [
        null,
        "Please make sure that the postal code is valid"
    ],
    "shippingaddresspanel.loading": [
        null,
        "Please be patient while we retrieve your information"
    ],
    "shippingaddresspanel.remove": [
        null,
        "Remove"
    ],
    "shippingaddresspanel.removeerror": [
        null,
        "An error occurred and the shipping address was not removed. Please try again."
    ],
    "shippingaddresspanel.requiredfieldmissing": [
        null,
        "Some required fields have not been filled"
    ],
    "ticketpriceselection.addtocartandcontinueshopping": [
        null,
        "Add and continue shopping"
    ],
    "ticketpriceselection.checkout": [
        null,
        "Check out"
    ],
    "ticketpriceselection.hereareyourprices": [
        null,
        "Here are your prices"
    ],
    "ticketpriceselection.membershipcardaddingsuccessfully": [
        null,
        "Membership card successfully added"
    ],
    "ticketpriceselection.membershipcardhasbeenfoundsuccessfully": [
        null,
        "Membership card found!"
    ],
    "ticketpriceselection.membersonly": [
        null,
        "Members only"
    ],
    "ticketpriceselection.nopricesavailable": [
        null,
        "No prices available"
    ],
    "ticketpriceselection.prices": [
        null,
        "Prices"
    ],
    "ticketpriceselection.qtytotalhigherthannumberofticketsreserved": [
        null,
        "You total number you entered in the prices **({qtyrequest})** is greater than the quantity of tickets we assigned you **({nbrtickets})**."
    ],
    "ticketpriceselection.qtytotallowerthannumberofticketsreserved": [
        null,
        "You total number you entered in the prices **({qtyrequest})** is lower than the quantity of tickets we assigned you **({nbrtickets})**."
    ],
    "ticketpriceselection.quantities": [
        null,
        "Quantities"
    ],
    "ticketpriceselection.rates": [
        null,
        "Rates"
    ],
    "ticketpriceselection.total": [
        null,
        "Total"
    ],
    "ticketpriceselection.totals": [
        null,
        "Totals"
    ],
    "ticketpriceselection.yoursaving": [
        null,
        "Save **{amount}** right now with the card"
    ],
    "venueplan.contextmenu.cancel": [
        null,
        "Cancel"
    ],
    "venueplan.contextmenu.lookfortickethere": [
        null,
        "Search here"
    ],
    "veuillez envoyer un courriel à ": [
        null,
        "please send an email to"
    ],
    "vider": [
        null,
        "empty"
    ],
    "year": [
        null,
        "year"
    ],
    "{ticketsNumber} billets": [
        null,
        "{ticketsNumber} tickets"
    ],
    "{ticketsNumber} billets {sectionName}": [
        null,
        "{ticketsNumber} tickets {sectionName}"
    ],
    "Éditer vos informations": [
        null,
        "Edit your information"
    ],
    "Êtes-vous membre ?": [
        null,
        "Are you a member?"
    ],
    "à intéragir avec ce site Web.": [
        null,
        "to interact with the web site"
    ],
    "à intéragir sur le site de": [
        null,
        "to interact with the web site"
    ],
    "Une erreur est survenue. Veuillez réessayer.": [
        null,
        "An error occurred. Please try again later."
    ],
    "(Québec)": [
        null,
        "(Québec)"
    ],
    "10h à 17h {timezone}": [
        null,
        "From 10am to 5pm {timezone}"
    ],
    "8h à 16h {timezone}": [
        null,
        "From 8am to 4pm {timezone}"
    ],
    "930 boul. Jacques-Cartier Est": [
        null,
        "930 Jacques Cartier East St"
    ],
    "9h à 20h {timezone}": [
        null,
        "From 9am to 8pm {timezone}"
    ],
    "Accéder à la liste des spectacles": [
        null,
        "Go to event list"
    ],
    "Acheter": [
        null,
        "Buy"
    ],
    "Acheté le : {purchaseDate}": [
        null,
        "Purchased on {purchaseDate}"
    ],
    "Administration": [
        null,
        "Administrative Office"
    ],
    "Admission générale": [
        null,
        "General admission"
    ],
    "Adresse": [
        null,
        "Address"
    ],
    "Adresse (suite)": [
        null,
        "Address line 2"
    ],
    "Adresse courriel": [
        null,
        "Email address"
    ],
    "Adresse de facturation": [
        null,
        "Billing address"
    ],
    "Adresses de livraison": [
        null,
        "Shipping address"
    ],
    "Adulte": [
        null,
        "Adult"
    ],
    "Afficher plus": [
        null,
        "Show more"
    ],
    "Ancien mot de passe": [
        null,
        "Previous password"
    ],
    "Annulé": [
        null,
        "Canceled"
    ],
    "Bonjour": [
        null,
        "Hello"
    ],
    "Bureau B-101": [
        null,
        "Office B-101"
    ],
    "Bureau administratif": [
        null,
        "Administrative office"
    ],
    "Cacher": [
        null,
        "Hide"
    ],
    "Capacité de la salle": [
        null,
        "Venue capacity"
    ],
    "Ce champ est requis.": [
        null,
        "Required field"
    ],
    "Centrale téléphonique": [
        null,
        "Call center"
    ],
    "Chicoutimi": [
        null,
        "Chicoutimi"
    ],
    "Combien de représentations avez-vous planifiées ?": [
        null,
        "How many event dates do you plan to produce?"
    ],
    "Commande annulée": [
        null,
        "Order cancelled"
    ],
    "Commentaires": [
        null,
        "Comments"
    ],
    "Complet": [
        null,
        "Soldout"
    ],
    "Confirmation du nouveau mot de passe": [
        null,
        "New password confirmation"
    ],
    "Confirmez votre nouveau mot de passe": [
        null,
        "Confirm your new password"
    ],
    "Confirmez votre nouvelle adresse courriel": [
        null,
        "Confirm your new email address"
    ],
    "Connectez-vous": [
        null,
        "Login"
    ],
    "Contact": [
        null,
        "Contact"
    ],
    "Courriel": [
        null,
        "Email"
    ],
    "Courriel :": [
        null,
        "Email:"
    ],
    "Courriel existant.": [
        null,
        "This email address already exists"
    ],
    "Date de la première représentation": [
        null,
        "First event date"
    ],
    "Description": [
        null,
        "Description"
    ],
    "Du {fromDate}": [
        null,
        "From {fromDate}"
    ],
    "Désirez-vous vraiment supprimer cette adresse?": [
        null,
        "Do you really want to delete this address?"
    ],
    "Email": [
        null,
        "Email"
    ],
    "En panne d'idée cadeau?": [
        null,
        "Gift ideas needed?"
    ],
    "En savoir plus": [
        null,
        "Learn more"
    ],
    "Enfant": [
        null,
        "Children"
    ],
    "English": [
        null,
        "English"
    ],
    "Femme": [
        null,
        "Women"
    ],
    "Fermé": [
        null,
        "Closed"
    ],
    "Français": [
        null,
        "Français"
    ],
    "G7H 7K9": [
        null,
        "G7H 7K9"
    ],
    "HAE": [
        null,
        "EDT"
    ],
    "HNE": [
        null,
        "EST"
    ],
    "Heures d'affaires": [
        null,
        "Business hours"
    ],
    "Homme": [
        null,
        "Men"
    ],
    "Informations à propos de votre événement": [
        null,
        "Information about your event"
    ],
    "J'ai les informations de l'événement": [
        null,
        "I have information about the event"
    ],
    "Je m'abonne": [
        null,
        "I subscribe"
    ],
    "Jusqu'au {toDate}": [
        null,
        "Until {toDate}"
    ],
    "La confirmation du mot de passe doit être identique au nouveau": [
        null,
        "The password confirmation must be identical"
    ],
    "Le cas échéant, qui vous a référé ?": [
        null,
        "Who referred you?"
    ],
    "Le mot de passe doit comprendre entre 5 et 25 caractères": [
        null,
        "The password must be 5 to 25 characters long"
    ],
    "Les champs en rouge sont obligatoires": [
        null,
        "The red fields are required"
    ],
    "Les deux": [
        null,
        "Both"
    ],
    "Lundi au vendredi": [
        null,
        "Monday to Friday"
    ],
    "M'enregistrer": [
        null,
        "Register"
    ],
    "Mauvais mot de passe.": [
        null,
        "Wrong password."
    ],
    "Me connecter": [
        null,
        "Login"
    ],
    "Me déconnecter": [
        null,
        "Logout"
    ],
    "Mes commandes": [
        null,
        "My orders"
    ],
    "Modification de l'adresse courriel": [
        null,
        "Email address modification"
    ],
    "Modifier le profil": [
        null,
        "Modify profile"
    ],
    "Modifier votre mot de passe": [
        null,
        "Change your password"
    ],
    "Mon profil": [
        null,
        "My profile"
    ],
    "Mot de passe": [
        null,
        "Password"
    ],
    "Mots de passes différents": [
        null,
        "Passwords different"
    ],
    "Nom": [
        null,
        "Name"
    ],
    "Nom complet": [
        null,
        "Full name"
    ],
    "Nom de famille": [
        null,
        "Last name"
    ],
    "Nom de la compagnie": [
        null,
        "Company name"
    ],
    "Nom de la salle": [
        null,
        "Venue name"
    ],
    "Nom de votre ou de vos événement(s) ?": [
        null,
        "Event name(s)"
    ],
    "Non": [
        null,
        "No"
    ],
    "Nous joindre": [
        null,
        "Contact us"
    ],
    "Nous n'avons trouvé aucun résultat pour votre recherche.": [
        null,
        "Your search did not return any results"
    ],
    "Nouveau mot de passe": [
        null,
        "New password"
    ],
    "Nouvelle adresse courriel": [
        null,
        "New email address"
    ],
    "Ok": [
        null,
        "Ok"
    ],
    "Optez pour un certificat-cadeau Reservatech.net. Choisissez le montant que vous désirez!": [
        null,
        "Opt for a Reservatech.net gift card. Make it the amount you want!"
    ],
    "Optionnel": [
        null,
        "Optional"
    ],
    "Oui": [
        null,
        "Yes"
    ],
    "Par catégorie": [
        null,
        "By category"
    ],
    "Par date": [
        null,
        "By dates"
    ],
    "Par région": [
        null,
        "By region"
    ],
    "Par salle": [
        null,
        "By venue"
    ],
    "Par événement ou artiste": [
        null,
        "By event or artist"
    ],
    "Pays": [
        null,
        "Country"
    ],
    "Points de vente": [
        null,
        "Point of sales"
    ],
    "Profil": [
        null,
        "Profile"
    ],
    "Programmation complète": [
        null,
        "Complete program"
    ],
    "Province": [
        null,
        "Province"
    ],
    "Prénom": [
        null,
        "First name"
    ],
    "Quand prévoyez-vous la mise en vente publique ?": [
        null,
        "When do you plan to open ticket sales to the general public?"
    ],
    "Quel est le prix des billets ?": [
        null,
        "How much will be your tickets?"
    ],
    "Quel est le type de billet ?": [
        null,
        "Kind of tickets"
    ],
    "Recevez toutes les nouvelles sur les spectacles à venir, les dates de mise en vente de billets, nos concours et plus encore...": [
        null,
        "Stay up to date with the upcoming events, ticket sale dates, contests and more..."
    ],
    "Restez informés": [
        null,
        "Stay informed"
    ],
    "Retourner à l'accueil": [
        null,
        "Go back to the home page"
    ],
    "Retourner à la vente standard": [
        null,
        "Return to the regular sale"
    ],
    "Réinitialisation de votre mot de passe": [
        null,
        "Reset your password"
    ],
    "Résultats": [
        null,
        "Results"
    ],
    "Samedi et dimanche": [
        null,
        "Saturday and Sunday"
    ],
    "Sièges réservés": [
        null,
        "Assigned seats"
    ],
    "Suivez-nous": [
        null,
        "Follow us"
    ],
    "Titre": [
        null,
        "Title"
    ],
    "Tél. :": [
        null,
        "Phone:"
    ],
    "Télécopieur :": [
        null,
        "Fax:"
    ],
    "Téléphone :": [
        null,
        "Phone:"
    ],
    "Téléphone sans frais :": [
        null,
        "Toll-free:"
    ],
    "Une erreur est apparue. Veuillez réessayer plus tard.": [
        null,
        "An error occurred. Please try again later."
    ],
    "Une fois votre demande de modification de votre courriel effectuée, un courriel sera envoyé à votre nouvelle adresse pour que vous puissiez confirmer la modification.": [
        null,
        "Once your request is sent, you will receive an email in which you can confirm the change"
    ],
    "Vendre un événement sur notre réseau": [
        null,
        "Sell an event through our network"
    ],
    "Veuillez prendre note qu’un courriel sera également envoyé à votre ancienne adresse pour mentionner la demande de changement.": [
        null,
        "Please note that an email will be sent to your previous address to inform about this change."
    ],
    "Veuillez remplir tous les champs qui ne sont pas optionnels": [
        null,
        "Please fill all fields that are mandatory"
    ],
    "Veuillez remplir tous les champs qui ne sont pas optionnels et vous assurer que le code postal est valide": [
        null,
        "Please fill all fields that are mandatory and make sure the postal code is valid"
    ],
    "Veuillez saisir un mot de passe de 5 à 11 lettres et/ou chiffres": [
        null,
        "Please enter a password of 5 to 11 characters long"
    ],
    "Veuillez vous assurer que le code postal est valide": [
        null,
        "Please make sure that the postal code is valid"
    ],
    "Vider": [
        null,
        "Clear"
    ],
    "Vidéo promotionnelle": [
        null,
        "Promotional video"
    ],
    "Ville": [
        null,
        "City"
    ],
    "Ville de la salle": [
        null,
        "Venue name city"
    ],
    "Voir la commande": [
        null,
        "View the order"
    ],
    "Vos Informations": [
        null,
        "Your Information"
    ],
    "Vos commandes": [
        null,
        "Your Orders"
    ],
    "Votre compte": [
        null,
        "Your Account"
    ],
    "Votre mot de passe a bien été changé.": [
        null,
        "Your password has been changed successfully"
    ],
    "Vous avez déjà modifié votre mot de passe.": [
        null,
        "You already have changed your password"
    ],
    "Vous n'avez encore fait aucun achat.": [
        null,
        "You don’t have any order yet."
    ],
    "© {currentYear} Reservatech | Tous droits réservés": [
        null,
        "© {currentYear} Reservatech | All rights reserved"
    ],
    "Événements les plus populaires": [
        null,
        "Popular Events"
    ],
    "Événements nouvellement mis en vente": [
        null,
        "New On Sale"
    ],
    "Événements à venir": [
        null,
        "Upcoming Events"
    ],
    "Code postal invalide": [
        null,
        "Invalid postal code"
    ],
    "Le nombre doit être un entier": [
        null,
        "The number must be an intégrer"
    ],
    "Nombre invalide": [
        null,
        "Invalid Number"
    ],
    "Vous devez cocher la case pour continuer": [
        null,
        "You must checked the box to continue"
    ],
    "tsadminreactcontrols.noitem": [
        null,
        "No item"
    ],
    "tsadminreactcontrols.processing": [
        null,
        "Process in progress..."
    ],
    "paging.first": [
        null,
        "First"
    ],
    "paging.last": [
        null,
        "Last"
    ],
    "paging.next": [
        null,
        "Next"
    ],
    "paging.previous": [
        null,
        "Previous"
    ]
};